import React from 'react'
import { titleCase } from 'title-case';
import { graphql } from 'gatsby'

import { Layout, PageCard, Pagination } from '../components/common'
import { MetaData } from '../components/common/meta'
import { slugToReferralMap } from '../data/referralInfo';
import { activePlatforms } from '../utils/constants';
import { slugToRatesMap } from '../data/ratesTableInfo';

/**
* Tag page (/tag/:slug)
*
* Loads all pages for the requested tag incl. pagination.
*
*/
const PagesTag = ({ data, location, pageContext }) => {
    const tag = data.ghostTag
    let pages = data.allGhostPage.edges

    // Sort referrals by referralOrder if tag is 'referrals'
    if (tag.name === 'referrals') {
        pages = [...pages].sort((a, b) => {
            const referralA = slugToReferralMap[a.node.slug];
            const referralB = slugToReferralMap[b.node.slug];
            
            const orderA = referralA?.referralOrder ?? Number.MAX_SAFE_INTEGER;
            const orderB = referralB?.referralOrder ?? Number.MAX_SAFE_INTEGER;
            
            return orderA - orderB;
        });
    }

    return (
        <>
            <MetaData
                data={data}
                location={location}
                type="series"
            />
            <Layout location={location}>
                <div className="container">
                    <header className="tag-header">
                        <h1>{tag.meta_title}</h1>
                        {tag.description ? <p>{tag.description}</p> : null }
                    </header>
                    <section className="post-feed">
                        {pages.map(({ node }) => {
                            let title = node.title;
                            if (tag.name === 'referrals') {
                                const referralNode = slugToReferralMap[node.slug];
                                if (referralNode === null) {
                                    return null;
                                }
                                if (referralNode.bonus) {
                                    title = titleCase(`${referralNode.name} - ${referralNode.bonus}`);
                                } else {
                                    title = referralNode.name;
                                }
                            }

                            if (tag.name === 'withdrawal fees') {
                                if (node.slug === 'finblox-withdrawal-fees') {
                                    return null;
                                }
                            }

                            if (tag.name === 'platform rates') {
                                const platformNode = slugToRatesMap[`/${node.slug}/`];
                                if (!activePlatforms.includes(platformNode?.key)) {
                                    return null;
                                }
                            }

                            return <PageCard key={node.id} post={node} title={title} />;
                        })}
                    </section>
                    <Pagination pageContext={pageContext} />
                </div>
            </Layout>
        </>
    )
}

export default PagesTag

export const pageQuery = graphql`
    query GhostTagQuery($slug: String!, $limit: Int!, $skip: Int!) {
        ghostTag(slug: { eq: $slug }) {
            ...GhostTagFields
        }
        allGhostPage(
            sort: { order: DESC, fields: [published_at] },
            filter: {tags: {elemMatch: {slug: {eq: $slug}}}},
            limit: $limit,
            skip: $skip
        ) {
            edges {
                node {
                ...GhostPageFields
                }
            }
        }
    }
`
